export enum QueryKey {
  getPayerProduct = 'getPayerProduct',
}
